/**
 * Onboarding — një vend për thirrjet e procesit.
 *
 * Lista faqoset te serveri: me njëqind procese aktive dhe një mijë e pesëqind
 * detyra, leximi i gjithçkaje te shfletuesi do të ishte i njëjti gabim që
 * Faza 1 e rekrutimit e rregulloi te kandidatët.
 */
import { authFetch } from './apiServices';

function qs(params = {}) {
  const sp = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v === undefined || v === null || v === '' || v === 'all') continue;
    sp.set(k, String(v));
  }
  const s = sp.toString();
  return s ? `?${s}` : '';
}

async function get(path) {
  try {
    const r = await authFetch(path).then((x) => x.json());
    return r?.success ? r.data : { error: r?.error || 'Kërkesa dështoi.' };
  } catch (_) {
    return { error: 'Lidhja me serverin dështoi.' };
  }
}

async function send(path, method, body) {
  try {
    const res = await authFetch(path, {
      method,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body || {}),
    });
    const r = await res.json();
    // Mbyllja e refuzuar kthen edhe detajet — çfarë mbeti pa u bërë.
    if (!r?.success) return { error: r?.error || 'Veprimi dështoi.', details: r?.data || null };
    return r.data;
  } catch (_) {
    return { error: 'Lidhja me serverin dështoi.' };
  }
}

const EMPTY = { data: [], pagination: { page: 1, limit: 25, total: 0, totalPages: 1 }, stats: null };

export default function onboardingService() {
  return {
    async list(params = {}) {
      const d = await get(`/api/onboarding${qs(params)}`);
      return d.error ? { ...EMPTY, error: d.error } : d;
    },
    detail(id) { return get(`/api/onboarding/${id}`); },
    config() { return get('/api/onboarding/config'); },
    templates() { return get('/api/onboarding/templates'); },
    template(id) { return get(`/api/onboarding/templates/${id}`); },
    legacyTasks() { return get('/api/onboarding/legacy-tasks'); },
    myTasks() { return get('/api/onboarding/my-tasks'); },

    createStandardTemplate() { return send('/api/onboarding/templates/standard', 'POST'); },
    saveTemplate(template, id) {
      return id ? send(`/api/onboarding/templates/${id}`, 'PUT', template)
                : send('/api/onboarding/templates', 'POST', template);
    },

    /** Nis procesin — gjithmonë me konfirmim njerëzor, kurrë vetvetiu. */
    start(payload) { return send('/api/onboarding', 'POST', payload); },
    update(id, patch) { return send(`/api/onboarding/${id}`, 'PUT', patch); },
    complete(id) { return send(`/api/onboarding/${id}/complete`, 'POST'); },
    cancel(id, reason) { return send(`/api/onboarding/${id}/cancel`, 'POST', { reason }); },
    reopen(id, reason) { return send(`/api/onboarding/${id}/reopen`, 'POST', { reason }); },
    linkWorker(id, workerId) { return send(`/api/onboarding/${id}/link-worker`, 'POST', { workerId }); },

    setTaskStatus(taskId, status, extra = {}) {
      return send(`/api/onboarding/tasks/${taskId}/status`, 'POST', { status, ...extra });
    },
    updateTask(taskId, patch) { return send(`/api/onboarding/tasks/${taskId}`, 'PUT', patch); },
  };
}
